import { type ReactNode, useId } from "react";

import "./ui.css";

interface FormFieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: (id: string) => ReactNode;
}

export function FormField({ label, hint, error, required = false, children }: FormFieldProps) {
  const id = useId();
  return (
    <div className="form-field">
      <label className="form-field__label" htmlFor={id}>
        {label}
        {required && <span className="form-field__required"> *</span>}
      </label>
      {children(id)}
      {hint && !error && <p className="form-field__hint">{hint}</p>}
      {error && (
        <p className="form-field__error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
